// Configuration publique du projet Firebase (aucune clé de compte de service).
// Les valeurs par défaut fonctionnent aussi dans Docker, où .env est exclu.
export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyDAHi0zARw1WSVfVc4Dn-bO3j6hOHKzORI",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "alomain-3da8e.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "alomain-3da8e",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "alomain-3da8e.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "471971890962",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:471971890962:web:014aff07e91ac89b1355cb",
};

export const firebaseVapidKey = import.meta.env.VITE_VAPID_PUBLIC_KEY ||
  "BGTSm1yMfukFGVlLQuXVjmEOzwyFfsSTIuZ9MdRlmeQ5BNVUrLPa0t6Kb_Hpeea5x-7mq6Pb5c7BbvugJVcdLgA";
